import type { AnvilCommand } from "./types";

export interface PaletteKeyActions {
  results: AnvilCommand[];
  /** Index of the currently highlighted result. */
  activeIndex: number;
  /** Moves the highlight to the given result index. */
  setActiveIndex: (index: number) => void;
  runCommand: (command: AnvilCommand) => void;
  close: () => void;
}

/**
 * Pure key handling for the command palette. Returns true when the key was
 * handled (so the caller can preventDefault). ArrowUp/ArrowDown move the active
 * highlight (wrapping at the ends); Enter runs the active result; Escape closes.
 * Kept pure so the behaviour is unit-testable without jsdom.
 */
export function handlePaletteKeyDown(
  key: string,
  actions: PaletteKeyActions,
): boolean {
  const count = actions.results.length;

  if (key === "ArrowDown") {
    if (count === 0) {
      return false;
    }

    actions.setActiveIndex((actions.activeIndex + 1) % count);

    return true;
  }

  if (key === "ArrowUp") {
    if (count === 0) {
      return false;
    }

    actions.setActiveIndex((actions.activeIndex - 1 + count) % count);

    return true;
  }

  if (key === "Enter") {
    const active = actions.results[actions.activeIndex] ?? actions.results[0];

    if (active) {
      actions.runCommand(active);

      return true;
    }

    return false;
  }

  if (key === "Escape") {
    actions.close();

    return true;
  }

  return false;
}
